import { render, staticRenderFns } from "./Group.vue?vue&type=template&id=4069a1bf"
import script from "./Group.vue?vue&type=script&lang=js"
export * from "./Group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports